import Icon from '@uconnect/assets/components/ui/icon';
import { AgentApiError, AGENT_ERROR_MESSAGES, type AgentApiErrorCode } from '../../../common/js/errors';

const ERROR_ICONS: Record<AgentApiErrorCode, string> = {
	rate_limited:    'clockRotateClockwise',
	llm_unavailable: 'offline',
	rag_unavailable: 'offline',
	auth:            'rectLogin',
	network:         'wifiOff',
};

interface ErrorMessageProps {
	error: unknown;
	onRetry?: () => void;
}

export default function ErrorMessage( { error, onRetry }: ErrorMessageProps ) {
	let code: AgentApiErrorCode | undefined;
	let description: string;

	if ( error instanceof AgentApiError ) {
		code = error.code;
		description = error.serverMessage ?? AGENT_ERROR_MESSAGES[ error.code ];
	} else {
		description = 'Something went wrong. Please try again.';
	}

	const iconName = code ? ERROR_ICONS[ code ] : 'triangleExclamation';

	return (
		<div className="flex! flex-col items-center justify-center gap-6 text-center p-8! rounded-2xl! bg-citation-background/40!">
			<div className="rounded-full p-5! bg-citation-background! text-citation-foreground!">
				<Icon
					name={ iconName }
					className="size-8"
				/>
			</div>
			<div className="flex flex-col gap-2">
				<h2 className="m-0! text-balance">
					Something interrupted your search
				</h2>
				<p className="text-muted-foreground! m-0! text-balance">
					{ description }
				</p>
			</div>
			{ onRetry && (
				<button
					className="button"
					onClick={ onRetry }
				>
					Retry
				</button>
			) }
		</div>
	);
}
